<h2
  [class.usda]="isUsda"
  data-cy="product-detail.nutritional-info.nutritions-facts-text"
>
  {{ 'i18n.productDetail.nutritionalInfo.nutritionsFacts' | translate }}
</h2>
<div class="nutrition-label">
  <ng-container *ngIf="!isUsda; else usdaServingsSection">
    <div
      class="serving-per-container"
      [attr.data-cy]="
        'product-servings-per-container-' +
        productDetail?.productNumber +
        '-text'
      "
      *ngIf="!!productDetail?.servingsPerCase"
    >
      {{ productDetail?.servingsPerCase }}
      {{
        'i18n.productDetail.nutritionalInfo.servingsPerContainer'
          | translate
          | lowercase
      }}
    </div>
    <div
      class="serving-size"
      [attr.data-cy]="
        'product-servings-size-' + productDetail?.productNumber + '-text'
      "
      *ngIf="!!servingSizeData"
    >
      <span class="label" data-cy="serving-size-label-text">
        {{ 'i18n.productDetail.nutritionalInfo.servingSize' | translate }}
      </span>
      <span class="size" data-cy="serving-size-data-text">
        {{ servingSizeData }}</span
      >
    </div>
  </ng-container>
  <ng-template #usdaServingsSection>
    <div
      class="serving-size"
      [attr.data-cy]="
        'product-servings-per-container-usda-' +
        productDetail?.productNumber +
        '-text'
      "
      *ngIf="!!servingSizeData"
    >
      <span class="label" data-cy="serving-size-label-usda-text">
        {{ 'i18n.productDetail.nutritionalInfo.servingSize' | translate }}
        {{ servingSizeData }}
      </span>
    </div>
    <div
      class="serving-per-container"
      [attr.data-cy]="
        'product-servings-per-container-usda-' +
        productDetail?.productNumber +
        '-text'
      "
      *ngIf="!!productDetail?.servingsPerCase"
    >
      {{
        'i18n.productDetail.nutritionalInfo.servingsPerContainer' | translate
      }}
      {{ productDetail?.servingsPerCase }}
    </div>
  </ng-template>
  <div
    class="divider-title"
    data-cy="divider-title-text"
    *ngIf="!!productDetail?.servingsPerCase || !!servingSizeData"
  ></div>
  <ng-container *ngIf="!isUsda; else usdaCaloriesSection">
    <div class="serving-summary" *ngIf="!nutrientIsNotAvailable">
      <div class="text-block" data-cy="serving-summary-text">
        <span
          class="subtitle"
          data-cy="nutritional-info-amount-per-serving-text"
        >
          {{
            'i18n.productDetail.nutritionalInfo.amountPerServing' | translate
          }}
        </span>
        <span class="title" data-cy="nutritional-info-calories-text">
          {{ 'i18n.productDetail.nutritionalInfo.calories' | translate }}
        </span>
      </div>
      <div class="calories-count" data-cy="calories-count-text">
        {{ calories }}
      </div>
    </div>
  </ng-container>
  <ng-template #usdaCaloriesSection>
    <div class="serving-summary usda" *ngIf="!nutrientIsNotAvailable">
      <div class="text-block">
        <span
          class="subtitle"
          data-cy="nutritional-info-amount-per-serving-usda-text"
        >
          {{
            'i18n.productDetail.nutritionalInfo.amountPerServing' | translate
          }}
        </span>
      </div>
      <div class="text-block" data-cy="serving-summary-usda-text">
        <span class="title" data-cy="nutritional-info-calories-usda-text">
          {{ 'i18n.productDetail.nutritionalInfo.calories' | translate }}
          {{ calories }}
        </span>
        <span
          class="title"
          [class.empty-calories-from-fat]="caloriesFromFat === null"
          data-cy="nutritional-info-calories-from-fat-usda-text"
        >
          {{ 'i18n.productDetail.nutritionalInfo.caloriesFromFat' | translate }}
          {{ caloriesFromFat }}
        </span>
      </div>
    </div>
  </ng-template>
  <div
    class="divider-table"
    data-cy="divider-table-text"
    *ngIf="!nutrientIsNotAvailable"
  ></div>
  <div class="table-head" data-cy="nutritional-info-daily-value-text">
    {{ 'i18n.productDetail.nutritionalInfo.dailyValue' | translate }}
  </div>
  <div class="row" *ngIf="nutrientIsNotAvailable">
    <i data-cy="nutritional-info-not-available-text">
      {{ 'i18n.productDetail.nutritionalInfo.notAvailable' | translate }}
    </i>
  </div>
  <ng-container *ngIf="!nutrientIsNotAvailable">
    <ng-container *ngFor="let nutrient of nutrientsData">
      <div class="row {{ nutrient.rowType }}">
        <span
          class="name"
          [attr.data-cy]="
            'nutritional-info-name-' + nutrient?.data.nutrientName + '-text'
          "
          *ngIf="!nutrient.altLabel"
        >
          {{ nutrient.data?.nutrientName }}
        </span>
        <span
          class="quantity"
          [attr.data-cy]="
            'nutritional-info-quantity-' + nutrient?.data.nutrientName + '-text'
          "
          *ngIf="
            !nutrient.altLabel &&
            nutrient.data?.nutrientValue !== null &&
            nutrient.data?.nutrientValue >= 0
          "
        >
          {{ nutrient.data?.nutrientValue }}
          {{ nutrient.data?.nutrientUom }}
        </span>
        <span
          class="name"
          [attr.data-cy]="
            'nutritional-info-name-' + nutrient?.data.nutrientName + '-text'
          "
          *ngIf="nutrient.altLabel"
          [innerHTML]="nutrient.altLabel"
        ></span>
        <span
          class="percentage"
          [attr.data-cy]="
            'nutritional-info-percentage-' +
            nutrient?.data.nutrientName +
            '-text'
          "
          *ngIf="
            nutrient.data?.nutrientRdvPercentage !== null &&
            nutrient.data?.nutrientRdvPercentage >= 0
          "
          >{{ nutrient.data?.nutrientRdvPercentage }}%</span
        >
      </div>
    </ng-container>
  </ng-container>
  <div class="divider-title" data-cy="divider-title-text"></div>
  <div class="supplemental-facts">
    <div
      class="supplemental-facts-header"
      data-cy="supplemental-facts-header-text"
    >
      {{ 'i18n.productDetail.nutritionalInfo.suplementalFacts' | translate }}
    </div>
    <div class="table-head" data-cy="daily-value-text">
      {{ 'i18n.productDetail.nutritionalInfo.dailyValue' | translate }}
    </div>
    <div class="row" *ngIf="supplementalFacts?.length === 0">
      <i>{{ 'i18n.productDetail.nutritionalInfo.notAvailable' | translate }}</i>
    </div>
    <div
      class="row"
      [attr.data-cy]="
        'nutritional-info-supplementary-facts-' + fact?.nutrientName + '-text'
      "
      *ngFor="let fact of supplementalFacts"
    >
      <span class="name regular">{{ fact.nutrientName }}</span>
      <span class="quantity"
        >{{ fact.nutrientValue }}{{ fact.nutrientUom }}</span
      >
      <span class="percentage" *ngIf="!!fact.nutrientRdvPercentage"
        >{{ fact.nutrientRdvPercentage }}%</span
      >
    </div>
  </div>
  <div class="divider-table" data-cy="divider-table-text"></div>
  <div class="footer-notes" data-cy="footer-text">
    {{ 'i18n.productDetail.nutritionalInfo.footer' | translate }}
  </div>
</div>
